import { useCallback } from 'react'

import { type UNSAFE_any } from '@flecto/types'

interface IFieldsError {
  [key: string]: {
    message?: string
  }
}

export const UseFormValidationHelper = (formErrors: UNSAFE_any) => {
  const hasError = useCallback(
    (key: string) => (Object.keys(formErrors) || []).includes(key),
    [formErrors]
  )

  const getError = useCallback(
    (key: string) => {
      try {
        const localErrors = { ...formErrors } as IFieldsError
        const { message } = localErrors[key]

        return message || ''
      } catch {
        return ''
      }
    },
    [formErrors]
  )

  const hasSomeError = useCallback(
    (keys: string[]) =>
      (Object.keys(formErrors) || []).some((item) => keys.includes(item)),
    [formErrors]
  )

  return {
    hasError,
    getError,
    hasSomeError,
  }
}
